var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 140,
    viewBox: "0 0 292 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 140,
    fill: "#F6F7F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.48 69.0063L143.105 63.1469C142.744 62.9211 142.289 62.9091 141.916 63.1156C141.544 63.3221 141.312 63.7146 141.312 64.1406V75.8594C141.312 76.2854 141.544 76.6778 141.916 76.8844C142.093 76.9825 142.289 77.0313 142.484 77.0313C142.7 77.0313 142.916 76.9716 143.105 76.8531L152.48 70.9938C152.823 70.7796 153.031 70.4041 153.031 70C153.031 69.5959 152.823 69.2204 152.48 69.0063ZM143.656 73.745V66.2549L149.648 70L143.656 73.745Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.141 54.7656H131.859C128.629 54.7656 126 57.3941 126 60.625V79.375C126 82.6059 128.629 85.2344 131.859 85.2344H160.141C163.371 85.2344 166 82.6059 166 79.375V60.625C166 57.3941 163.371 54.7656 160.141 54.7656ZM163.656 79.375C163.656 81.3135 162.079 82.8906 160.141 82.8906H131.859C129.921 82.8906 128.344 81.3135 128.344 79.375V60.625C128.344 58.6865 129.921 57.1094 131.859 57.1094H160.141C162.079 57.1094 163.656 58.6865 163.656 60.625V79.375Z",
    fill: "#98A2B3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadVideo);
export default __webpack_public_path__ + "static/media/upload-video.ebcc1e51626cde3b3f8ad21d81b6fb55.svg";
export { ForwardRef as ReactComponent };